module.exports = __webpack_public_path__ + "static/media/GN.00df87f5.svg";